/* SET STATE */
export const SET_STATE_COORDINATION = "SET_STATE_COORDINATION"

/* COORDINATIONS */
export const GET_COORDINATIONS = "GET_COORDINATIONS"
export const GET_COORDINATIONS_SUCCESS = "GET_COORDINATIONS_SUCCESS"
export const GET_COORDINATIONS_FAIL = "GET_COORDINATIONS_FAIL"

/* COORDINATION */
export const GET_COORDINATION = "GET_COORDINATION"
export const GET_COORDINATION_SUCCESS = "GET_COORDINATION_SUCCESS"
export const GET_COORDINATION_FAIL = "GET_COORDINATION_FAIL"

/**
 * ADD COORDINATION
 */
 export const ADD_NEW_COORDINATION = "ADD_NEW_COORDINATION"
 export const ADD_COORDINATION_SUCCESS = "ADD_COORDINATION_SUCCESS"
 export const ADD_COORDINATION_FAIL = "ADD_COORDINATION_FAIL"

 /**
 * UPDATE COORDINATION
 */
export const UPDATE_COORDINATION = "UPDATE_COORDINATION"
export const UPDATE_COORDINATION_STATUS = "UPDATE_COORDINATION_STATUS"
export const UPDATE_COORDINATION_SUCCESS = "UPDATE_COORDINATION_SUCCESS"
export const UPDATE_COORDINATION_FAIL = "UPDATE_COORDINATION_FAIL"

/**
 * DELETE COORDINATION
 */
export const DELETE_COORDINATION = "DELETE_COORDINATION"
export const DELETE_COORDINATION_SUCCESS = "DELETE_COORDINATION_SUCCESS"
export const DELETE_COORDINATION_FAIL = "DELETE_COORDINATION_FAIL"
